import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "../ui/chart";
import type { WeekTotals } from "./metrics";

const cycleConfig = {
  medianCycleHours: { label: "Median cycle (h)", color: "var(--chart-1)" },
} satisfies ChartConfig;

export function CycleTimeChart({ totals }: { totals: WeekTotals[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Cycle time</CardTitle>
        <CardDescription>Median hours from created to completed, per week</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={cycleConfig} className="aspect-auto h-64 w-full">
          <LineChart data={totals} margin={{ left: -20, right: 4 }}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="week" tickLine={false} axisLine={false} tickMargin={8} />
            <YAxis tickLine={false} axisLine={false} width={40} />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Line
              type="monotone"
              dataKey="medianCycleHours"
              stroke="var(--color-medianCycleHours)"
              strokeWidth={2}
              dot={false}
              connectNulls
            />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
